var _excluded = ["title", "onCloseButtonClick", "handleCloseButtonClick", "isLoading"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../contexts/OnColorContext";
import useSwipeOnMobile from "../../../../hooks/useSwipeOnMobile";
import breakpoint from "../../../../utils/breakpoint";
import getBorderColor from "../../../../utils/getBorderColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import TextAtm from "../../../atoms/TextAtm";
import PushOrg from "../../../organisms/PushOrg";
import CloseButtonAtm from "../CloseButtonAtm";
var LoaderSvg = function LoaderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  }))));
};
LoaderSvg.defaultProps = {
  width: "44",
  height: "44",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor"
};
import { surfaceOrgBreakpointSpacingSpace, surfaceOrgSpacingSpace } from "../ModalOrg/ModalOrg.settings";
import { breakpointValue } from "../ModalTemplate.settings";
var Container = styled.div.withConfig({
  componentId: "sc-15p02gm-0"
})(function (_ref) {
  var $hasTitle = _ref.$hasTitle,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:flex;align-items:center;justify-content:", ";padding:", ";padding-bottom:", ";", " ", " ", "{padding:", ";padding-bottom:", ";}"], $hasTitle ? "space-between" : "flex-end", space(surfaceOrgSpacingSpace), $hasTitle ? space(2) : 0, $hasTitle && css(["border-bottom:", " solid ", ";"], unit(1), getBorderColor(theme, $onColor, "low")), !$hasTitle && css(["width:100%;"]), breakpoint(breakpointValue), space(surfaceOrgBreakpointSpacingSpace), $hasTitle ? space(2.5) : 0);
});
function ModalHeaderMol(_ref2) {
  var title = _ref2.title,
    onCloseButtonClick = _ref2.onCloseButtonClick,
    handleCloseButtonClick = _ref2.handleCloseButtonClick,
    isLoading = _ref2.isLoading,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  var _useSwipeOnMobile = useSwipeOnMobile(handleCloseButtonClick, false),
    onTouchStart = _useSwipeOnMobile.onTouchStart,
    onTouchMove = _useSwipeOnMobile.onTouchMove,
    onTouchEnd = _useSwipeOnMobile.onTouchEnd;
  return /*#__PURE__*/React.createElement(Container, _extends({
    $hasTitle: !!title,
    $onColor: onColor
  }, restProps, {
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }), isLoading && title ? /*#__PURE__*/React.createElement(LoaderSvg, null) : null, !isLoading && title ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "medium3_h"
  }, title) : null, onCloseButtonClick ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: isLoading ? 2 : 0,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(CloseButtonAtm, {
    onClick: handleCloseButtonClick
  })) : null);
}
export default ModalHeaderMol;